import { useEcomConfig } from "hooks/useEcomConfig";
import { useAppSelector } from "State/Hooks";
import { RootState } from "State/store";
import { menuVisibilityRules } from "Types/Admin/menuVisibilityConfig";
import {
  ApertureIcon,
  BasketDiscountIcon,
  BookCopy,
  BoxIcon,
  CalendarIcon,
  CircleIcon,
  FactoryIcon,
  FolderIcon,
  GalleryVerticalIcon,
  GroupIcon,
  HomeIcon,
  LanguagesIcon,
  LayersIcon,
  LibraryBigIcon,
  PackageIcon,
  PaletteIcon,
  PercentIcon,
  RulerIcon,
  ScissorsIcon,
  SettingsIcon,
  ShirtIcon,
  ShoppingBagIcon,
  PackagePlusIcon,
  SignatureIcon,
  TagIcon,
  TagsIcon,
  WavesIcon,
} from "Utilities/AdminIcons";
import { getBrandName } from "Utilities/templateUtils";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { ECOMAdminLoyaltyPointsRoute } from "routes/routes.constant";

interface MenuItem {
  name: string;
  icon: React.ElementType;
  href?: string;
  submenu?: MenuItem[];
}

interface AdminSidebarProps {
  open: boolean;
  toggleSidebar: () => void;
  collapsed: boolean;
  toggleCollapse: () => void;
}

const menuItems: MenuItem[] = [
  { name: "Dashboard", icon: HomeIcon, href: "/admin/" },
  { name: "Banner", icon: GalleryVerticalIcon, href: "/admin/banner" },
  // { name: "Visualization", icon: GalleryVerticalIcon, href: "/admin/Analytic" },
  // { name: "Sections", icon: LayersIcon, href: "/admin/sections" },
  {
    name: "Product",
    icon: PackageIcon,
    submenu: [
      { name: "Product", icon: ShoppingBagIcon, href: "/admin/product" },
      { name: "Product Group", icon: GroupIcon, href: "/admin/product-group" },
      { name: "Category", icon: TagIcon, href: "/admin/product-category" },
      {
        name: "Sub Category",
        icon: FolderIcon,
        href: "/admin/product-subclass",
      },
      { name: "Author", icon: SignatureIcon, href: "/admin/author" },
      { name: "Language", icon: LanguagesIcon, href: "/admin/language" },
      { name: "Academic", icon: LibraryBigIcon, href: "/admin/academic" },
      { name: "Merchandise", icon: TagsIcon, href: "/admin/merchandise" },
      // {
      //   name: "Sub Category",
      //   icon: FolderIcon,
      //   href: "/admin/product-subcategory",
      // },
      // { name: "Brand", icon: FactoryIcon, href: "/admin/product-brand" },
      // { name: "Model", icon: BoxIcon, href: "/admin/product-model" },
      // { name: "Size", icon: RulerIcon, href: "/admin/product-size" },
      // { name: "Sleeve", icon: ShirtIcon, href: "/admin/product-sleeve" },
      // { name: "Color", icon: PaletteIcon, href: "/admin/product-color" },
      // { name: "Fabric", icon: ScissorsIcon, href: "/admin/product-fabric" },
      // { name: "Occasion", icon: CalendarIcon, href: "/admin/product-occasion" },
      // { name: "Collar", icon: CircleIcon, href: "/admin/product-collar" },
      // { name: "Pattern", icon: WavesIcon, href: "/admin/product-pattern" },
    ],
  },
  {
    name: "Promotion",
    icon: PercentIcon,
    submenu: [
      {
        name: "Product",
        icon: ShoppingBagIcon,
        href: "/admin/product-promotion",
      },
      {
        name: "Bulk Product",
        icon: PackagePlusIcon,
        href: "/admin/bulk-product-promotion",
      },
      { name: "Category", icon: TagIcon, href: "/admin/category-promotion" },
      {
        name: "Overall",
        icon: PercentIcon,
        href: "/admin/overall",
      },
      // { name: "Brand", icon: ApertureIcon, href: "/admin/brand-promotion" },
    ],
  },
  {
    name: "Loyalty Points",
    icon: BasketDiscountIcon,
    href: ECOMAdminLoyaltyPointsRoute,
  },
  {
    name: "Sell Books",
    icon: BookCopy,
    href: "/admin/sell-books",
  },
  {
    name: "Other Details",
    icon: FolderIcon,
    submenu: [
      {
        name: "Events",
        icon: CalendarIcon,
        href: "/admin/other-details/events",
      },
      {
        name: "Gallery",
        icon: TagIcon,
        href: "/admin/other-details/glossary",
      },
      // { name: "Gallery", icon: GalleryVerticalIcon, href: "/admin/other-details/gallery" },
      {
        name: "History",
        icon: SignatureIcon,
        href: "/admin/other-details/history",
      },
    ],
  },

  { name: "Settings", icon: SettingsIcon, href: "/admin/settings/social-media" },
];

const bookMenuItems: MenuItem[] = [
  { name: "Dashboard", icon: HomeIcon, href: "/admin/" },
  { name: "Banner", icon: GalleryVerticalIcon, href: "/admin/banner" },
  {
    name: "Product",
    icon: PackageIcon,
    submenu: [
      { name: "Product", icon: ShoppingBagIcon, href: "/admin/product" },
      { name: "Product Group", icon: GroupIcon, href: "/admin/product-group" },
      { name: "Category", icon: TagIcon, href: "/admin/product-category" },
      {
        name: "Sub Category",
        icon: FolderIcon,
        href: "/admin/product-subclass",
      },
      { name: "Author", icon: SignatureIcon, href: "/admin/author" },
      { name: "Language", icon: LanguagesIcon, href: "/admin/language" },
      { name: "Academic", icon: LibraryBigIcon, href: "/admin/academic" },
      { name: "Merchandise", icon: TagsIcon, href: "/admin/merchandise" },
    ],
  },
  {
    name: "Promotion",
    icon: PercentIcon,
    submenu: [
      {
        name: "Product",
        icon: ShoppingBagIcon,
        href: "/admin/product-promotion",
      },
      {
        name: "Bulk Product",
        icon: PackagePlusIcon,
        href: "/admin/bulk-product-promotion",
      },
      { name: "Category", icon: TagIcon, href: "/admin/category-promotion" },
      {
        name: "Overall",
        icon: PercentIcon,
        href: "/admin/overall",
      },
    ],
  },
  {
    name: "Loyalty Points",
    icon: BasketDiscountIcon,
    href: ECOMAdminLoyaltyPointsRoute,
  },
  {
    name: "Sell Books",
    icon: BookCopy,
    href: "/admin/sell-books",
  },
  {
    name: "Other Details",
    icon: FolderIcon,
    submenu: [
      {
        name: "Events",
        icon: CalendarIcon,
        href: "/admin/other-details/events",
      },
      {
        name: "Glossary",
        icon: TagIcon,
        href: "/admin/other-details/glossary",
      },
      {
        name: "History",
        icon: SignatureIcon,
        href: "/admin/other-details/history",
      },
    ],
  },

  { name: "Settings", icon: SettingsIcon, href: "/admin/settings/social-media" },
];

const TextileMenuItems: MenuItem[] = [
  { name: "Dashboard", icon: HomeIcon, href: "/admin/" },
  { name: "Banner", icon: GalleryVerticalIcon, href: "/admin/banner" },
  { name: "Sections", icon: LayersIcon, href: "/admin/sections" },
  {
    name: "Product",
    icon: PackageIcon,
    submenu: [
      { name: "Product", icon: ShoppingBagIcon, href: "/admin/product" },
      { name: "Product Group", icon: GroupIcon, href: "/admin/product-group" },
      { name: "Category", icon: TagIcon, href: "/admin/product-category" },
      {
        name: "Sub Category",
        icon: FolderIcon,
        href: "/admin/product-subcategory",
      },
      { name: "Brand", icon: FactoryIcon, href: "/admin/product-brand" },
      { name: "Model", icon: BoxIcon, href: "/admin/product-model" },
      { name: "Size", icon: RulerIcon, href: "/admin/product-size" },
      { name: "Sleeve", icon: ShirtIcon, href: "/admin/product-sleeve" },
      { name: "Color", icon: PaletteIcon, href: "/admin/product-color" },
      { name: "Fabric", icon: ScissorsIcon, href: "/admin/product-fabric" },
      { name: "Occasion", icon: CalendarIcon, href: "/admin/product-occasion" },
      { name: "Collar", icon: CircleIcon, href: "/admin/product-collar" },
      { name: "Pattern", icon: WavesIcon, href: "/admin/product-pattern" },
    ],
  },
  {
    name: "Promotion",
    icon: PercentIcon,
    submenu: [
      {
        name: "Product",
        icon: ShoppingBagIcon,
        href: "/admin/product-promotion",
      },
      {
        name: "Bulk Product",
        icon: PackagePlusIcon,
        href: "/admin/bulk-product-promotion",
      },
      { name: "Category", icon: TagIcon, href: "/admin/category-promotion" },
      {
        name: "Overall",
        icon: PercentIcon,
        href: "/admin/overall",
      },
      { name: "Brand", icon: ApertureIcon, href: "/admin/brand-promotion" },
    ],
  },
  { name: "Settings", icon: SettingsIcon, href: "/admin/settings/social-media" },
];

// ===============================
// AdminSidebar.tsx (UPDATED)
// ===============================

const AdminSidebar: React.FC<AdminSidebarProps> = ({
  open,
  toggleSidebar,
  collapsed,
  toggleCollapse,
}) => {
  const navigate = useNavigate();
  const { selected } = useSelector((state: RootState) => state.template);
  const brandName = getBrandName(selected);
  const { showAuthor, showLanguage, showAcademic, showMerchandise, showEvents, showGlossary, showHistory, isLoyaltyPointsEnabled, showPromotion, showSellBooks } = useEcomConfig();
  const isMobile = window.innerWidth < 768;
  const isCollapsed = !isMobile && collapsed;

  const config = useAppSelector((state: any) => state.configuration.config);

  const [expandedMenus, setExpandedMenus] = useState<Record<string, boolean>>(
    {},
  );

  const location = useLocation();

  const [currentPath, setCurrentPath] = useState<string>(location.pathname);
  const sidebarRef = useRef<HTMLDivElement>(null);

  const storeType = process.env.REACT_APP_STORE_TYPE || "default";
  const rules = menuVisibilityRules[storeType] || {};

  const baseMenuItems = React.useMemo(() => {
    let items = menuItems;
    if (config?.industryType === "Books") {
      items = bookMenuItems;
    } else if (config?.industryType === "Textile") {
      items = TextileMenuItems;
    }

    return items.filter((item) => {
      if (item.name === "Loyalty Points" && !isLoyaltyPointsEnabled) return false;
      if (item.name === "Promotion" && !showPromotion) return false;
      if (item.name === "Sell Books" && !showSellBooks) return false;
      return true;
    });
  }, [config?.industryType, isLoyaltyPointsEnabled, showPromotion, showSellBooks]);

  const filteredMenuItems = baseMenuItems
    .filter(
      (item) =>
        !rules.hideMenuItems?.includes(item.name) &&
        !(
          item.name === "Other Details" &&
          !showEvents &&
          !showGlossary &&
          !showHistory
        ),
    )
    .map((item) => {
      const subItemsToHide = rules.hideSubMenuItems?.[item.name];

      return {
        ...item,
        submenu: item.submenu
          ? item.submenu.filter((sub) => {
              if (subItemsToHide?.includes(sub.name)) return false;
              if (sub.name === "Author" && !showAuthor) return false;
              if (sub.name === "Language" && !showLanguage) return false;
              if (sub.name === "Academic" && !showAcademic) return false;
              if (sub.name === "Merchandise" && !showMerchandise) return false;
              if (sub.name === "Events" && !showEvents) return false;
              if (sub.name === "Glossary" && !showGlossary) return false;
              if (sub.name === "History" && !showHistory) return false;
              return true;
            })
          : undefined,
      };
    });

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);

  useEffect(() => {
    const newExpanded: Record<string, boolean> = {};

    filteredMenuItems.forEach((item) => {
      if (
        item.submenu &&
        item.submenu.some((sub) => sub.href === location.pathname)
      ) {
        newExpanded[item.name] = true;
      }
    });

    setExpandedMenus((prev) => ({ ...prev, ...newExpanded }));
  }, [location.pathname]);

  const handleMenuClick = () => {
    if (window.innerWidth < 768) {
      toggleSidebar();
    }
  };

  const toggleSubmenu = useCallback((name: string) => {
    setExpandedMenus((prev) => ({ ...prev, [name]: !prev[name] }));
  }, []);

  return (
    <div
      ref={sidebarRef}
      className={`
    fixed md:relative
    top-0 left-0 h-full
    ${isCollapsed ? "md:w-20 w-64" : "w-64"} bg-white border-r border-gray-300
    flex flex-col
overflow-hidden
    transition-all duration-300 ease-in-out
    font-body font-bold
    z-40
    ${open ? "translate-x-0" : "-translate-x-full md:translate-x-0"}
  `}
    >
      {/* ===== BRAND HEADER (Aligned with Navbar height) ===== */}
      <div className="h-[70px] px-6 flex items-center bg-white">
        <div className="flex items-center gap-4">
          {/* Logo */}
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#2563EB] to-[#6366F1] flex items-center justify-center">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 5h2l3 12h10l3-8H6" />
              <circle cx="9" cy="20" r="1.5" />
              <circle cx="18" cy="20" r="1.5" />
            </svg>
          </div>

          {!isCollapsed && (
            <h1 className="text-xl font-bold text-[#0B132B] tracking-tight">
              {brandName || "Moore Market"}
            </h1>
          )}
        </div>
      </div>

      {/* ===========================
         MENU SECTION
         =========================== */}
      <nav className="flex-1 px-4 py-5 overflow-y-auto scrollbar-hide">
        <ul className="space-y-2">
          {filteredMenuItems.map((item) => {
            const isActive =
              currentPath === item.href ||
              item.submenu?.some((sub) => sub.href === currentPath);

            return (
              <li key={item.name}>
                {item.submenu ? (
                  <>
                    <button
                      onClick={() => {
                        if (isCollapsed && item.submenu?.length) {
                          navigate(item.submenu[0].href || "#");
                        } else {
                          toggleSubmenu(item.name);
                        }
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-bold transition-all duration-200 ${
                        isActive
                          ? "bg-gradient-to-r from-[#2563EB] via-[#3B82F6] to-[#6366F1] text-white shadow-md"
                          : "text-[#0F172A] hover:bg-[#EEF2FF] hover:text-[#2563EB]"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <item.icon className="w-5 h-5" />
                        {!isCollapsed && item.name}
                      </div>

                      <svg
                        className={`w-4 h-4 transition-transform ${
                          expandedMenus[item.name] ? "rotate-90" : ""
                        }`}
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 18l6-6-6-6" />
                      </svg>
                    </button>

                    {!isCollapsed && expandedMenus[item.name] && (
                      <ul className="mt-3 ml-6 space-y-1.5">
                        {item.submenu?.map((subItem) => {
                          const subActive = currentPath === subItem.href;

                          return (
                            <li key={subItem.name}>
                              <Link
                                to={subItem.href || "#"}
                                onClick={handleMenuClick}
                                className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all duration-200 ${
                                  subActive
                                    ? "bg-[#E0E7FF] text-[#2563EB] font-bold"
                                    : "text-gray-900 font-medium hover:bg-[#EEF2FF] hover:text-[#2563EB]"
                                }`}
                              >
                                <subItem.icon className="w-4 h-4" />
                                {subItem.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.href || "#"}
                    onClick={handleMenuClick}
                    className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-bold transition-all duration-200 ${
                      isActive
                        ? "bg-gradient-to-r from-[#2563EB] via-[#3B82F6] to-[#6366F1] text-white shadow-md"
                        : "text-[#0F172A] hover:bg-[#EEF2FF] hover:text-[#2563EB]"
                    }`}
                  >
                    <item.icon className="w-5 h-5" />
                    {!isCollapsed && item.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default AdminSidebar;
